var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('qr-code',{attrs:{"size":300,"error-level":"H","text":_vm.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }